/**
 * Archived portfolio. The Person node is owned by janduras.com.
 * This page only points at that @id. It does not repeat profiles,
 * job title, email, or companies.
 */
const archivedSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://jan.duras.me/#webpage",
  url: "https://jan.duras.me/",
  name: "Ján Ďuraš (Jan Duras) — site moved",
  description:
    "Archived former portfolio. The current site is https://janduras.com.",
  mainEntity: { "@id": "https://janduras.com/#person" },
};

export default archivedSiteSchema;
